import React from "react";
import { extractErrorMessage } from "../../../util/api";
import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { useTableContext } from "../../components/AdministrateTable";
import { useDestroyPermission } from "../../utils";

export const PayorPortalManagementActionCell = ({ mappingId, ...row }) => {
  const { refresh, setMessage, setError } = useTableContext();

  const [canDestroy] = useDestroyPermission("PayorPortalMapping", mappingId);

  return (
    canDestroy && (
      <AdministrateResourceDeleteButton
        label="Remove"
        deleteUrl={`/admin/payor_portal_mappings/${mappingId}`}
        onError={(err) => setError(extractErrorMessage(err))}
        onSuccess={() => {
          setMessage("Successfully removed Payor Portal Mapping");
          refresh();
        }}
      />
    )
  );
};
